import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Creators as LocalsCreators } from 'store/ducks/locals';

import locationsIcon from 'assets/img/locations-icon.svg';

import Section from 'components/Section';
import TextButton from 'components/Button/TextButton';
import Pagination from 'components/Pagination';
import PaginationSize from 'components/PaginationSize';
import SearchInput from 'components/SearchInput';

import { Creators as FormCreators } from 'store/ducks/serviceForm';

import searchFailIcon from 'assets/img/search-fail.svg';
import { gaSendEvent } from '../../utils/analytics';

import {
  BoxLocals, Header, SearchFail, Footer,
} from './styles';

import LocalsTable from './LocalsTable';
import { DeleteLocalModal, UnauthorizedLocalModal } from './LocalsModal';

const Locals = ({
  _openForm,
  _localsRequest,
  _includeLocal,
  _editLocal,
  locals,
  auth,
  _finishForm,
  _deleteLocal,
}) => {
  const [modalDeleteIsOpen, setModalDeleteIsOpen] = useState(false);
  const [unauthorizedModalIsOpen, setUnauthorizedModalIsOpen] = useState(false);
  const [offsetPagination, setOffsetPagination] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLocalToDelete, setSelectedLocalToDelete] = useState(null);

  const getLocals = async () => {
    await _localsRequest({
      offset: offsetPagination,
      term: searchTerm,
    });
  };

  useEffect(() => {
    if (searchTerm) {
      // avoid get data on every key typing
      const searching = setTimeout(() => {
        getLocals();
      }, 500);
      return () => {
        clearTimeout(searching);
      };
    }

    getLocals();
  }, [offsetPagination, searchTerm]); // [] => rerender when change data inside array

  const search = async (e) => {
    e.preventDefault();
    setOffsetPagination(0);
    setSearchTerm(e.target.value);
  };

  const toggleUnauthorizedModal = () => {
    setUnauthorizedModalIsOpen(!unauthorizedModalIsOpen);
  };

  const toggleDeleteModal = (local) => {
    const { addresses_integration } = auth.triiderUser.company;
    if (addresses_integration) return toggleUnauthorizedModal();

    gaSendEvent('endereco', 'deletar');
    setModalDeleteIsOpen(!modalDeleteIsOpen);
    setSelectedLocalToDelete(local);
  };

  const confirmDeleteLocal = async () => {
    await _deleteLocal(selectedLocalToDelete);
    setModalDeleteIsOpen(!modalDeleteIsOpen);
  };

  const changePage = async (offset) => {
    setOffsetPagination(offset);
  };

  const NoSearchResults = () => (
    <SearchFail>
      <img src={searchFailIcon} alt="Search Fail Icon" />
      <h3>PESQUISA SEM RESULTADOS</h3>
      <p>
        Sua pesquisa não teve resultado.
        {' '}
        <br />
        {' '}
        Altere sua busca ou adicione um novo local.
      </p>
    </SearchFail>
  );

  const addLocal = () => {
    const { addresses_integration } = auth.triiderUser.company;
    if (addresses_integration) return toggleUnauthorizedModal();

    gaSendEvent('adicionar_local', 'locais');
    _openForm({
      isOpen: true,
      isFormAddress: true,
      onFinish: payload => _includeLocal(payload),
    });
  };

  const editLocal = (address) => {
    const { addresses_integration } = auth.triiderUser.company;
    if (addresses_integration) return toggleUnauthorizedModal();

    gaSendEvent('endereco', 'editar');
    _openForm({
      isOpen: true,
      isFormAddress: true,
      address,
      // onFinish: _editLocal,
    });
  };

  const createTask = (address) => {
    gaSendEvent('novo_pedido', 'locais');
    _openForm({
      isOpen: true,
      isFormAddress: false,
      address: null,
      onFinish: _finishForm,
      selectedAddress: address,
    });
  };

  return (
    <Section color="#FBFBFB">
      <Helmet title="Triider - Meus endereços" />
      <BoxLocals>
        <Header>
          <SearchInput
            value={searchTerm}
            onChange={e => search(e)}
            type="text"
            name="Search Term"
          />
          <TextButton
            onClick={() => addLocal()}
            btnIcon={locationsIcon}
            btnWidth="185px"
            btnHeight="50px"
          >
            Adicionar Local
          </TextButton>
        </Header>
        {searchTerm
          && locals
          && locals.companyLocals
          && locals.companyLocals.addresses
          && locals.companyLocals.addresses.length == 0 && <NoSearchResults />}
        <LocalsTable
          locals={locals.companyLocals}
          toggleDeleteModal={toggleDeleteModal}
          toggleEditModal={address => editLocal(address)}
          toggleServiceForm={address => createTask(address)}
        />

        {locals
          && locals.companyLocals
          && locals.companyLocals.addresses
          && locals.companyLocals.addresses.length > 0 && (
            <Footer>
              <PaginationSize
                length={20}
                offset={offsetPagination}
                name="Locais"
                full={locals.companyLocals ? locals.companyLocals.total : 0}
              />
              <Pagination
                total={locals.companyLocals ? locals.companyLocals.total : 0}
                listMaxLength={20}
                offset={offsetPagination}
                setOffset={changePage}
              />
            </Footer>
        )}
      </BoxLocals>
      <DeleteLocalModal
        modalIsOpen={modalDeleteIsOpen}
        toggle={toggleDeleteModal}
        confirmDelete={confirmDeleteLocal}
      />
      <UnauthorizedLocalModal
        modalIsOpen={unauthorizedModalIsOpen}
        toggle={toggleUnauthorizedModal}
      />
    </Section>
  );
};

const mapStateToProps = ({ locals, auth }) => ({
  locals,
  auth,
});

const mapDispatchToProps = {
  _localsRequest: LocalsCreators.getLocalsRequest,
  _openForm: FormCreators.openForm,
  _finishForm: FormCreators.finishFormRequest,
  _includeLocal: LocalsCreators.includeLocalRequest,
  _editLocal: LocalsCreators.editLocalRequest,
  _deleteLocal: LocalsCreators.deleteLocalRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Locals);
